<div class="subBlockContainer" id="AMPSubscriptionCancellationComponent">
  <div class="subBlockContent">
    <child-header [title]="'Cancellation'" (closeEvent)="close()"></child-header>
    <div class="child-body">
      <div class="inner-subBlock-wrapper">
        <div class="col-md-12">
          <div class="tab-content" id="pills-tabContent">
            <div>
              <mat-spinner style="margin: auto;" mode="indeterminate"
                class="circle" diameter="20"
                *ngIf="tableLoading">
              </mat-spinner>
            </div>
            <div class="my-4" *ngIf="tableResult?.length" >
              <div style="overflow-y: auto; height: 500px;">
                <table mat-table [dataSource]="tableResult">
                  <ng-container matColumnDef="orderId">
                    <th class="align-left table-column" style="text-align: left;" mat-header-cell *matHeaderCellDef width="15%">ORDER ID</th>
                    <td class="tb-row" mat-cell *matCellDef="let element" width="15%" style="white-space: pre; text-align: left;">
                      {{ element.orderId }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="stockCode">
                    <th class="align-left table-column" style="text-align: left;" mat-header-cell *matHeaderCellDef width="15%">STOCK CODE</th>
                    <td class="tb-row" mat-cell *matCellDef="let element" width="15%"style="white-space: pre; text-align: left;">
                      {{ element.offerId }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="custReference">
                    <th class="align-left table-column" style="text-align: left;" mat-header-cell *matHeaderCellDef width="15%">CUSTOMER REFERENCE</th>
                    <td class="tb-row" mat-cell *matCellDef="let element" width="15%" style="white-space: pre;text-align: left;">
                      {{ element.externalReferenceId }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="createdTime">
                    <th class="align-left table-column" style="text-align: left;" mat-header-cell *matHeaderCellDef width="15%">CREATED TIME</th>
                    <td class="align-left tb-row" mat-cell *matCellDef="let element" width="15%" style="white-space: pre;">
                      {{ element.creationDate | date: 'dd/MM/yyyy h:mm a' }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="lineItemNumber">
                    <th class="align-center table-column" style="text-align: right;" mat-header-cell *matHeaderCellDef width="10%">LINE ITEM ID</th>
                    <td class="align-center tb-row" mat-cell *matCellDef="let element" width="10%" style="white-space: pre; text-align: right;">
                      {{ element.extLineItemNumber }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="qty">
                    <th class="align-center table-column" style="text-align: right;" mat-header-cell *matHeaderCellDef width="10%">QUANTITY</th>
                    <td class="align-center tb-row" mat-cell *matCellDef="let element" width="10%"
                     style="white-space: pre; text-align: right;">{{ element.quantity }}</td> 
                  </ng-container>
                  <ng-container matColumnDef="cancelButton">
                    <th class="align-center table-column" mat-header-cell *matHeaderCellDef width="10%">
                    </th>
                    <td class="align-center" mat-cell *matCellDef="let element; let i = index" width="10%"
                      class="tb-row" style="white-space: pre;">
                      <button
                        *ngIf="!element.isCancelling"
                        class="button button-red button-round" style="float: right;"
                        (click)="cancelAMPSub(element, i)">Cancel
                      </button>
                      <mat-spinner
                        *ngIf="element.isCancelling"
                        style="margin: auto;" mode="indeterminate"
                        class="circle" diameter="20"
                      >
                      </mat-spinner>
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
              </div>
            </div>

            <div class="col-md-12 align-center" *ngIf="!tableResult?.length && !tableLoading">
              <label class="noData-label">
                  No items found
              </label>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <router-outlet></router-outlet>

</div>
